var LRUCacheNode = function () {
  function LRUCacheNode(key, value, next, prev) {
    this.key = key;
    this.value = value;
    this.next = next || null;
    this.prev = prev || null;
  }
  return LRUCacheNode;
}();

export { LRUCacheNode as default };
//# sourceMappingURL=index.js.map
